module.exports = "./img/4f47d9e1bc299d7f20af8bc5065f555b.jpg";